import { render, staticRenderFns } from "./VolunteerInvite.vue?vue&type=template&id=77d75bda&"
import script from "./VolunteerInvite.vue?vue&type=script&lang=js&"
export * from "./VolunteerInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports